import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  toggleGroupFullWidth: {
    marginBottom: theme.spacing(1),
    width: '100%',
    '& .MuiToggleButtonGroup-root': {
      width: '100%'
    },
    '& .MuiToggleButton-root': {
      flex: 1
    }
  }
}));
